import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import { isServer } from '@/helpers/isServer';

import { userBasketPersistReducer, userBasketReducer } from './slices/userBasketSlice';
import { userSessionPersistReducer, userSessionReducer } from './slices/userSessionSlice';
import { UserConfigureBundlePersistReducer, UserConfigureBundleReducer } from './slices/userConfigureBundleSlice';

export const store = isServer
  ? configureStore({
      reducer: {
        userBasket: userBasketReducer,
        userSession: userSessionReducer,
        userConfigureBundle: UserConfigureBundleReducer,
      },
    })
  : configureStore({
      reducer: {
        userBasket: userBasketPersistReducer,
        userSession: userSessionPersistReducer,
        userConfigureBundle: UserConfigureBundlePersistReducer,
      },
      middleware: getDefaultMiddleware => {
        return getDefaultMiddleware({
          serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          },
        });
      },
    });

export const persistor = persistStore(store);

setupListeners(store.dispatch);

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export * from './slices/userBasketSlice';
export * from './slices/userSessionSlice';
export * from './slices/userConfigureBundleSlice';

if (!isServer && process.env.GATSBY_OPCO == 'PT') {
  window.addEventListener('beforeunload', async () => {
    await persistor.flush();
  });
}
